import React from 'react';
import './AgentItem.scss';
import FormattedText, { IFormattedText } from 'Components/Shared/FormattedText/FormattedText';
import { FormattedDate, FormattedTime } from 'react-intl';

interface IProps {
  agent: Julius.Website.AgentViewModel;
}

const AgentItem: React.SFC<IProps> = ({
  agent: {
    name,
    phone,
    address,
    city,
    extraInfo,
    imageUrl,
    openHoursList,
  },
}) => (
<div className='agent-item'>
  <div className='image' style={ { backgroundImage: `url(${ imageUrl })` } } />
  <div className='info'>
    <div className='name'>{ name }</div>
    { extraInfo && 
      <span className='md'>{ extraInfo }</span> 
    }
    { address && city &&
      <div>
        <FormattedText 
          style='sub-title'
          displayName='Adress'
          formattedName='info.agents.address'
        />
        { address }, { city }
      </div>
    }
    { phone &&
      <div>
        <FormattedText 
          style='sub-title'
          displayName='Telefon'
          formattedName='info.agents.phone'
        />
        { phone }
      </div>
    }
    { openHoursList && openHoursList.length &&
      <div className='hours'>
        <FormattedText 
          style='sub-title'
          displayName='Öppettider'
          formattedName='info.agents.hours'
        />
        { openHoursList.map((item, key) => <HoursItem { ... { key, item } } />) }
      </div>
    }
    </div>
  </div>
);

const HoursItem: React.SFC<{ 
  item: Julius.Website.AgentOpenHourViewModel;
}> = ({
  item,
}) => {

  const { date, open1, open2, close1, close2 } = item;

  const isClosed =  
    open1.getTime() === close1.getTime() && 
    open2.getTime() === close2.getTime();

  if (isClosed) {
    return (
      <div className='hours-item'>
        <FormattedDate 
          value={ date }
          month='numeric'
          day='numeric'
          weekday='short'
        />:&nbsp;
        <FormattedText 
          displayName='Stängt'
          formattedName='info.agents.closed'
        />
      </div>
    );
  }

  const isWithBreak = open2.getTime() !== close2.getTime();

  return (
    <div className='hours-item'>
      <FormattedDate 
        value={ date }
        month='numeric'
        day='numeric'
        weekday='short'
      />:&nbsp;
      <FormattedTime value={ open1 } />-
      <FormattedTime value={ close1 } />
      { isWithBreak &&
        <>
          ,&nbsp;
          <FormattedTime value={ open2 } />-
          <FormattedTime value={ close2 } />
        </>
      }
    </div>
  );
};

export default AgentItem;


// WEBPACK FOOTER //
// ./src/components/InfoAgents/AgentItem/AgentItem.tsx